import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LinkedTicketsService } from 'src/app/core/services/ticket/linked-tickets.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../../../shared/modal-windows/confirmation-modal/confirmation-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { TicketRightPanelService } from '../../../core/services/ticket-right-panel.service';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { RelatedTicketModel } from '../../../core/models/related-ticket-model.model';
import { FormsModule } from '@angular/forms';
import { FocusDirective } from '../../../../sb-tools/typescript/directives/focus.directive';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'app-linked-tickets',
    templateUrl: './linked-tickets.component.html',
    styleUrls: ['./linked-tickets.component.scss'],
    imports: [FormsModule, FocusDirective, NgClass, TranslateModule, RouterLink, InlineSVGComponent],
})
export class LinkedTicketsComponent implements OnInit, OnDestroy {
    @Input() ticket: DetailedTicketDTO;

    isFocusNeeded: boolean;
    isSubmitted = false;
    linkedTickets: RelatedTicketModel[] = [];
    newLinkedTicketId = '';

    private unsubscriber = new Subject<void>();

    constructor(
        private linkedTicketsService: LinkedTicketsService,
        private bsModalService: BsModalService,
        private translateService: TranslateService,
        private ticketRightPanelService: TicketRightPanelService,
    ) {}

    ngOnInit() {
        this.loadLinkedTickets();
        this.isFocusNeeded = this.ticketRightPanelService.data?.isFocusNeeded;
    }

    addLinkedTicket(linkedTicketId, isValidTicketId) {
        this.isSubmitted = true;
        if (this.newLinkedTicketId && isValidTicketId) {
            this.linkedTicketsService
                .add(this.ticket.id, linkedTicketId)
                .pipe(takeUntil(this.unsubscriber))
                .subscribe(() => {
                    this.newLinkedTicketId = '';
                    this.isSubmitted = false;
                    this.loadLinkedTickets();
                });
        }
    }

    deleteLinkedTicket(linkedTicketId) {
        this.linkedTicketsService
            .remove(this.ticket.id, linkedTicketId)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.loadLinkedTickets();
            });
    }

    loadLinkedTickets() {
        this.linkedTicketsService
            .getAll(this.ticket.id)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data: RelatedTicketModel[]) => {
                this.linkedTickets = data;
            });
    }

    openRemoveLinkedTicketModal(removedTicketId) {
        const initialState = {
            title: this.translateService.instant('Are you sure you want to delete link to this ticket?'),
            confirmText: this.translateService.instant('Delete'),
            declineText: this.translateService.instant('Cancel'),
            confirmCallback: () => {
                return this.deleteLinkedTicket(removedTicketId);
            },
        };

        this.bsModalService.show(ConfirmationModalComponent, {
            initialState,
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
